export function deleteCookie(name) {
  const variants = [
    `${name}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=/;`,
    `${name}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=/; domain=.multi-mir.ru;`,
    `${name}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=/; domain=multi-mir.ru;`,
  ];

  variants.forEach((cookie) => {
    document.cookie = cookie;
    if (window.location.protocol === 'https:') {
      document.cookie = `${cookie}; Secure`;
    }
  });
}